import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementLabel } from './ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import { NoInternetPage } from '../ui/NoInternetPage'
import { Pulse } from '../ui/Pulse'
import { SVG_PlayIcon } from '../svg/SVG_PlayIcon'
import { Video } from '../ui/Video'
import { withS3ImageUrl } from '../file/withS3Url'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    url: string
    isOnline: () => Promise<boolean>
    openOptions?: () => void
}

interface State {
    playingVideo: boolean
    isOnline: boolean
}

export class ElementVideoContent extends React.Component<Props, State> {
    public state: State = { playingVideo: false, isOnline: null }

    public render = () => renderCatch(this.props.deps, this.tryRender)

    private playVideo = () => {
        this.setState({
            playingVideo: true,
        })
    }

    public componentDidMount = () => {
        this.setOnlineStatus()
    }

    private setOnlineStatus = async () => {
        this.setState({
            isOnline: await this.props.isOnline(),
        })
    }

    private renderContent = () => {
        const { deps, url } = this.props
        const { playingVideo } = this.state

        if (playingVideo) {
            return <Video deps={deps} url={url} autoPlay={true} />
        }

        return (
            <div className="AppCore__flow__ElementVideoContent__thumbnail" onClick={this.playVideo}>
                <SVG_PlayIcon />
                {withS3ImageUrl(deps, url, ({ thumbnailS3Url }) => (
                    <img src={thumbnailS3Url} />
                ))}
            </div>
        )
    }

    private tryRender = () => {
        const { deps, elementId, label } = this.props
        const { isOnline } = this.state

        if (isOnline == null) {
            return <Pulse />
        }

        if (!isOnline) {
            return <NoInternetPage deps={deps} onClick={this.setOnlineStatus} />
        }

        return (
            <ExecutionElement
                deps={this.props.deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={[]}
            >
                <ElementLabel
                    required={false}
                    label={label}
                    validationMessages={[]}
                    openOptions={this.props.openOptions}
                />
                <div className="AppCore__flow__ElementVideoContent">{this.renderContent()}</div>
            </ExecutionElement>
        )
    }
}
